export default class BarChart {
  constructor(controller) {
    this.dataset = controller.datasetValue
    this.chart = controller.chart
  }

  setChart() {
    const dataset = {
      dimensions: ['name', 'value'],
      source: this.dataset
    }

    const labelStyle = {
      fontFamily: 'Work Sans'
    }

    const axisLineStyle = {
      color: '#EBEBEB'
    }

    const option = {
      dataset,
      grid: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 30,
        containLabel: true
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          color: '#80868C',
          fontSize: 14,
          ...labelStyle
        },
        axisLine: {
          show: true,
          lineStyle: axisLineStyle
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: [4, 4],
            dashOffset: -1,
            ...axisLineStyle
          }
        }
      },
      yAxis: {
        type: 'category',
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#0A2540',
          fontSize: 16,
          fontWeight: 500,
          width: 160,
          overflow: 'break',
          ...labelStyle
        },
        axisLine: {
          lineStyle: axisLineStyle
        }
      },
      series: [
        {
          type: 'bar',
          barWidth: '70%',
          barGap: '14',
          itemStyle: {
            color: '#E0E0E0',
            borderRadius: [0, 5, 5, 0]
          },
          emphasis: {
            itemStyle: {
              color: '#FF5800'
            }
          },
          label: {
            show: true,
            position: 'right',
            distance: 10,
            color: '#80868C',
            fontSize: 14,
            ...labelStyle
          }
        }
      ]
    }

    this.chart.setOption(option)
  }
}
